module.exports = __webpack_public_path__ + "static/img/download5.ac7f4ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/trade/img/download5.png
// module id = 0utj
// module chunks = 1